import { useCallback, useEffect, useRef, useState } from "react";

/** Keep successful Rush item completions visible even when polling omits them. */
export default function useRushCompletedTickets(scope) {
  const [state, setState] = useState({ scope, orders: {} });
  const currentScope = useRef(scope);
  currentScope.current = scope;
  useEffect(() => { setState({ scope, orders: {} }); }, [scope]);

  const remember = useCallback((order, taskIds) => {
    if (currentScope.current !== scope || !order?.id) return;
    setState((previous) => {
      const orders = previous.scope === scope ? previous.orders : {};
      const items = new Map((orders[order.id]?.items || []).map((item) => [item.taskId, item]));
      (order.items || []).forEach((item) => {
        if (taskIds.includes(item?.taskId)) {
          items.set(item.taskId, { ...item, status: "COMPLETED", taskStatus: "COMPLETED" });
        }
      });
      return { scope, orders: { ...orders, [order.id]: { ...order, items: [...items.values()] } } };
    });
  }, [scope]);

  const forget = useCallback((jobId) => {
    if (currentScope.current !== scope) return;
    setState((previous) => {
      if (previous.scope !== scope) return previous;
      const orders = { ...previous.orders };
      delete orders[jobId];
      return { scope, orders };
    });
  }, [scope]);

  return { orders: state.scope === scope ? state.orders : {}, remember, forget };
}
